<script>
import { mapActions } from "vuex";
import cryptoRandomString from "crypto-random-string";
import APIService from "@/services/api.service";

export default {
	name: "masterWilayahForm",
	data() {
		return {
			mode: "INSERT",
			myData: {},
			show: true,
			showImages: false,
			message: "",
			myOptions: {
				status: [
					{ text: "-", value: null },
					{ text: "Aktif", value: 1 },
					{ text: "Non Aktif", value: 0 },
				],
				kabupaten: [],
			},
			params: {},
			headers: {},
			imgDataUrl: "",
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
	},
	components: {},
	created() {
		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			console.log(parseInt(this.$route.params.id));

			this.myData = this.$store.getters["masterWilayah/getById"](
				parseInt(this.$route.params.id)
			);

			console.log(this.myData);

			if (this.myData) {
				this.imgDataUrl = APIService.getImagePengguna(this.myData.img);
			} else {
				this.$router.push("/wilayah");
			}
		} else {
			this.myData.uid = cryptoRandomString({
				length: 16,
				type: "distinguishable",
			});

			this.myData.nama = this.$faker().name.findName();
			this.myData.pelindung = this.$faker().name.findName();
			this.myData.ketua = this.$faker().name.findName();
			this.myData.sekretaris = this.$faker().name.findName();
			this.myData.bendahara = this.$faker().name.findName();

         this.myData.ketua_nohp = this.$faker().phone.phoneNumber();
         this.myData.sekretaris_nohp = this.$faker().phone.phoneNumber();
         this.myData.bendahara_nohp = this.$faker().phone.phoneNumber();
		}

		// this.params = { uid: this.myData.uid };
		// this.headers = APIService.getHeader();
	},
	methods: {
		// ...mapActions("pengguna", ["insert", "update"]),
		...mapActions({
			insert: "masterWilayah/insert",
			update: "masterWilayah/update",
		}),
		onSubmit() {
			if (this.mode === "INSERT") {
				this.insert(this.myData).then(() => {
					this.$router.push("/wilayah");
				});
			} else {
				this.update(this.myData).then(() => {
					this.$router.push("/wilayah");
				});
			}
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs main="wilayah" title="Form Wilayah" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<form
								@submit.prevent="onSubmit"
								v-if="show"
								id="form-data"
							>
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label>Nama</label>
												<input
													v-model="myData.nama"
													class="form-control"
													type="text"
													required
												/>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>Pelindung</label>
												<input
													v-model="myData.pelindung"
													class="form-control"
													type="text"
												/>
											</div>
										</div>
									</div>
									<hr />
									<div class="row">
										<div class="col-md-4">
											<div class="form-group">
												<label>Ketua Wilayah</label>
												<input
													v-model="myData.ketua"
													class="form-control"
													type="text"
												/>
											</div>
											<div class="form-group">
												<label>No HP</label>
												<input
													v-model="myData.ketua_nohp"
													class="form-control"
													type="text"
												/>
											</div>
											<div class="form-group">
												<label>Alamat</label>
												<input
													v-model="myData.ketua_alamat"
													class="form-control"
													type="text"
												/>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>Sekretaris Wilayah</label>
												<input
													v-model="myData.sekretaris"
													class="form-control"
													type="text"
												/>
											</div>
											<div class="form-group">
												<label>No HP</label>
												<input
													v-model="myData.sekretaris_nohp"
													class="form-control"
													type="text"
												/>
											</div>
											<div class="form-group">
												<label>Alamat</label>
												<input
													v-model="myData.sekretaris_alamat"
													class="form-control"
													type="text"
												/>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>Bendahara Wilayah</label>
												<input
													v-model="myData.bendahara"
													class="form-control"
													type="text"
												/>
											</div>
											<div class="form-group">
												<label>No HP</label>
												<input
													v-model="myData.bendahara_nohp"
													class="form-control"
													type="text"
												/>
											</div>
											<div class="form-group">
												<label>Alamat</label>
												<input
													v-model="myData.bendahara_alamat"
													class="form-control"
													type="text"
												/>
											</div>
										</div>
									</div>
									<hr />
									<div class="row">
										<div class="col">
											<div class="form-group mb-0">
												<b-button
													class="mr-3"
													type="submit"
													variant="primary"
													:disabled="isLoading"
													form="form-data"
												>
													<span
														v-show="isLoading"
														class="spinner-border spinner-border-sm"
													></span
													><i
														class="fa fa-fw fa-save"
														v-show="!isLoading"
													></i>
													Simpan
												</b-button>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</px-card>
				</div>
			</div>
		</div>
		<!-- Container-fluid Ends-->
	</div>
</template>

